export default "__VITE_ASSET__m6AVnYj3__"